// import { PayloadAction } from '@reduxjs/toolkit'
import { SagaIterator } from 'redux-saga'
import {  hideLoader, showLoader } from '../slices'
import { call, put, select, takeLatest } from 'redux-saga/effects'
import {
  getFieldPermissionsApi,
  // getPermissionsOfFunctionalitiesByIdApi,
  // putPermissionsOfFunctionalitiesByIdApi,
} from '../apis/permissions.api'
import {
  getFieldPermissions,
  // getPermissionById,
  updateFieldPermissions,
  // updatePermissionsAction,
  // updatePermissionState,
} from '../slices/permissions.slice'
// import { v4 as uuid } from 'uuid'
// import {
//   ApplicationDataType,
//   FeatureDataType,
//   ModuleDataType,
//   PermissionDataType,
//   selectedPermissionData,
//   updateFunctionalityPayload,
// } from '../types/permissions.types'
import { FieldPermissions } from '../types/fieldPermissions'

// function* fetchPermissionsById(
//   action: PayloadAction<{ id: number }>
// ): SagaIterator {
//   try {
//     yield put(showLoader())
//     const response = yield call(
//       getPermissionsOfFunctionalitiesByIdApi,
//       action.payload
//     )
//     if (response.data) {
//       ;(response.data as selectedPermissionData).applications.sort(
//         (a, b) => a.application_id - b.application_id
//       )
//       response.data.applications.forEach((application: ApplicationDataType) => {
//         const parentApplicationId = application.application_id
//         application.modules.sort((a, b) => a.module_id - b.module_id)
//         application.modules.forEach((module: ModuleDataType) => {
//           module.application_id = parentApplicationId
//           const parentModuleId = module.module_id
//           module.features.sort((a, b) => a.feature_id - b.feature_id)
//           module.features.forEach((feature: FeatureDataType) => {
//             feature.module_id = parentModuleId
//             const parentFeatureId = feature.feature_id
//             feature.permissions.sort(
//               (a, b) => a.permission_id - b.permission_id
//             )
//             feature.permissions.forEach((permission: PermissionDataType) => {
//               permission.feature_id = parentFeatureId
//             })
//           })
//         })
//       })

//       yield put(updatePermissionState(response.data))
//     }
//   } catch (err) {
//     console.log(err)
//   } finally {
//     yield put(hideLoader())
//   }
// }

// function* updatePermissions(
//   action: PayloadAction<updateFunctionalityPayload>
// ): SagaIterator {
//   try {
//     yield put(showLoader())
//     const response = yield call(
//       putPermissionsOfFunctionalitiesByIdApi,
//       action.payload
//     )
//     if (response.data) {
//       yield put(getPermissionById({ id: action.payload.id }))
//       yield put(
//         addToaster({
//           message: 'Permissions updated successfully!',
//           type: 'success',
//           id: uuid(),
//         })
//       )
//     }
//   } catch (err) {
//     console.log(err)
//   } finally {
//     yield put(hideLoader())
//   }
// }

function* fetchFieldPermissions(): SagaIterator {
  try {
    yield put(showLoader())
    const isSuperAdmin = yield select(
      (state) => state?.authUser?.user?.superAdmin
    ) ?? false
    if (isSuperAdmin) return

    const response = yield call(getFieldPermissionsApi)

    const permissions: FieldPermissions = {}
    Object.entries(response.data?.aggregated_permissions ?? {}).forEach(
      ([entityId, entity]: typeof response.data.aggregated_permissions) => {
        const fieldPermissions: (typeof permissions)['']['fieldPermissions'] =
          {}
        Object.entries(entity.excluded_fields_permissions ?? {}).forEach(
          ([fieldId, field]: typeof entity.excluded_fields_permissions) => {
            fieldPermissions[fieldId] = {
              canView: !(field.operation & 1),
              canEdit: !(field.operation & 2),
            }
          }
        )
        permissions[entityId] = {
          canView: !!(entity.operation & 1),
          canEdit: !!(entity.operation & 2),
          canCreate: !!(entity.operation & 4),
          fieldPermissions,
        }
      }
    )

    yield put(updateFieldPermissions(permissions))
  } catch (err) {
    console.error(err)
  } finally {
    yield put(hideLoader())
  }
}

// export function* watchFetchPermissionsById() {
//   yield takeLatest(getPermissionById.type, fetchPermissionsById)
// }

export function* watchFetchFieldPermissions() {
  yield takeLatest(getFieldPermissions.type, fetchFieldPermissions)
}

// export function* watchUpdatePermissions() {
//   yield takeLatest(updatePermissionsAction.type, updatePermissions)
// }
